var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStateSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1087 51.8139C39.9759 51.8139 51.2174 40.4388 51.2174 26.4069C51.2174 12.3751 39.9759 1 26.1087 1C12.2416 1 1 12.3751 1 26.4069C1 40.4388 12.2416 51.8139 26.1087 51.8139Z",
    fill: "#F0FBFF",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0849 46.1198C23.4031 46.366 24.7442 46.494 26.1082 46.5037C37.0778 46.5037 45.9703 37.5055 45.9703 26.4056C45.9703 15.3058 37.0778 6.30762 26.1082 6.30762C23.2903 6.30762 20.6095 6.9014 18.1812 7.97207C13.9615 9.83264 10.5045 13.1333 8.41668 17.2606C7.02897 20.0038 6.24609 23.1122 6.24609 26.4056C6.24609 29.3938 6.89056 32.2297 8.04653 34.7786C8.87181 36.5984 9.95779 38.272 11.2561 39.7504",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0849 46.1198C23.4031 46.366 24.7442 46.494 26.1082 46.5037C37.0778 46.5037 45.9703 37.5055 45.9703 26.4056C45.9703 15.3058 37.0778 6.30762 26.1082 6.30762C23.2903 6.30762 20.6095 6.9014 18.1812 7.97207C13.9615 9.83264 10.5045 13.1333 8.41668 17.2606C7.02897 20.0038 6.24609 23.1122 6.24609 26.4056C6.24609 29.3938 6.89056 32.2297 8.04653 34.7786C8.87181 36.5984 9.95779 38.272 11.2561 39.7504",
    stroke: "#00A4BF",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 42.0146C15.1999 43.3388 17.0188 44.413 18.9889 45.1787",
    stroke: "#00A4BF",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7188 46.5059L51.2158 51.0564",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4897 50.3178C49.0711 51.7533 49.0711 54.0806 50.4897 55.5161L58.7983 63.9234C60.2169 65.3588 62.517 65.3588 63.9356 63.9234C65.3542 62.4879 65.3542 60.1605 63.9356 58.7251L55.627 50.3178C54.2084 48.8823 51.9084 48.8823 50.4897 50.3178Z",
    fill: "#F0FBFF",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2148 51.8145L62.4595 60.157",
    stroke: "white",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2376 17.6829C21.2376 26.479 28.2846 33.6097 36.9774 33.6097C38.6851 33.6097 40.3292 33.3345 41.8689 32.8256C39.3558 39.1363 33.2467 43.5909 26.1095 43.5909C16.7292 43.5909 9.125 35.8964 9.125 26.4047C9.125 17.8039 15.3687 10.6788 23.5199 9.41699C22.0718 11.8274 21.2376 14.6566 21.2376 17.6829Z",
    fill: "#F0FBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.483 12.376C25.5285 12.376 24.596 12.471 23.6942 12.6522M20.9701 13.4955C15.8428 15.6757 12.2422 20.8053 12.2422 26.7859",
    stroke: "#00BADB",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateSearch);
export default __webpack_public_path__ + "static/media/empty-state-search.bb3f9abaf225c5dd6cdc2b5e149de292.svg";
export { ForwardRef as ReactComponent };